import {
  DisplayProperties,
  ErrorMessages,
  getEmptyContent
} from '@com-delta-idp/mnx-skymiles-shared';

export const getBaseContentError = (
  error: string | undefined
): DisplayProperties => {
  // Using mock data(errorMessages) for now for getting error details if error messages are not available
  return getEmptyContent<DisplayProperties>(error, ErrorMessages);
};
